import { useAtomValue, useSetAtom } from 'jotai';
import { ButtonType } from '../../../views/Button';
import { CursiveHeadlineLabel, LabelBody, LabelDisplay1 } from '../components';
import {
    exercisesForCurrentSegmentAtom,
    reportExerciseProgressAtom,
} from '../data';
import { ExerciseDto, ExerciseStatus, ExerciseType } from '../interfaces';
import { openEvaluation } from '../nativeAPI';
import { useNavigation } from '../useNavigation';
import { useTitle } from '../useTitle';
import { ExerciseView } from './ExerciseView';
import { SegmentBar } from './SegmentBar';

export type ExercisesProps = { exercises: ExerciseDto[] };

type Props = {
    title: string;
    headline: React.ReactNode;
    description: React.ReactNode;
    segments?: [string, string];
    Exercises?: (props: ExercisesProps) => React.ReactNode;
};
export function ModuleDetailsView({
    title,
    headline,
    description,
    segments,
    Exercises = DefaultExercises,
}: Props) {
    useTitle(title);
    const exercises = useAtomValue(exercisesForCurrentSegmentAtom);

    return (
        <div className="three-blobs-img-1 container-in-app flex flex-col px-20">
            <CursiveHeadlineLabel className="my-60 text-center">
                {headline}
            </CursiveHeadlineLabel>

            <div>
                <LabelDisplay1>Om modulet</LabelDisplay1>
                <LabelBody>{description}</LabelBody>
            </div>

            {segments && (
                <SegmentBar segment1={segments[0]} segment2={segments[1]} />
            )}

            <Exercises exercises={exercises} />
        </div>
    );
}

function DefaultExercises({ exercises }: ExercisesProps) {
    return exercises.map((exercise) => (
        <DefaultExerciseView key={exercise.Id} exercise={exercise} />
    ));
}

type DefaultExerciseViewProps = {
    exercise: ExerciseDto;
    buttonType?: ButtonType;
    children?: React.ReactNode;
};
export function DefaultExerciseView({
    exercise,
    buttonType,
    children,
}: DefaultExerciseViewProps) {
    const navigate = useNavigation();
    const reportExerciseProgress = useSetAtom(reportExerciseProgressAtom);

    return (
        <ExerciseView
            className="mt-20"
            exercise={exercise}
            buttonType={buttonType}
            onOpenExercise={() => {
                if (exercise.Type === ExerciseType.Feedback) {
                    openEvaluation();
                    return;
                }
                navigate.toExercise(exercise, 1);
            }}
            showVideoInline
            onVideoPlayed={() => {
                if (exercise.Status == ExerciseStatus.Completed) {
                    return;
                }

                reportExerciseProgress({
                    exercise,
                    updateRequest: {
                        CurrentPage: null,
                        Data: null,
                        UpdatedStatus: ExerciseStatus.Completed,
                    },
                });
            }}
            children={children}
        />
    );
}
